var chunkMapping = {
	"0": [
		4648
	],
	"3": [
		4055,
		4348
	],
	"78": [
		5082
	],
	"163": [
		5169
	],
	"164": [
		5170
	],
	"167": [
		5173
	],
	"168": [
		5174
	],
	"169": [
		5175
	],
	"170": [
		5176
	],
	"171": [
		5177
	],
	"172": [
		5178
	],
	"173": [
		5179
	],
	"174": [
		5180
	],
	"175": [
		5181
	],
	"176": [
		5182
	],
	"177": [
		5183
	],
	"178": [
		5184
	],
	"179": [
		5185
	],
	"180": [
		5186
	],
	"181": [
		5187
	],
	"182": [
		5188
	],
	"183": [
		5189
	],
	"184": [
		5190
	],
	"185": [
		5191
	],
	"186": [
		5192
	]
};
var idToExternalAndNameMapping = {
	"4055": [
		"default",
		"./nuorder-components",
		3670
	],
	"4348": [
		"default",
		"./helios-components",
		3670
	],
	"4648": [
		"default",
		"./Containers",
		3580
	],
	"5082": [
		"default",
		"./OrderlessInvoices",
		3580
	],
	"5169": [
		"default",
		"./AsyncEventTracker",
		3580
	],
	"5170": [
		"default",
		"./HostWrapper",
		3580
	],
	"5173": [
		"default",
		"./CheckoutV3",
		3580
	],
	"5174": [
		"default",
		"./CheckoutConfirmation",
		3580
	],
	"5175": [
		"default",
		"./ContactCreditCards",
		3580
	],
	"5176": [
		"default",
		"./AuditDialog",
		3580
	],
	"5177": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3580
	],
	"5178": [
		"default",
		"./InvoiceDialog",
		3580
	],
	"5179": [
		"default",
		"./PaymentDueModal",
		3580
	],
	"5180": [
		"default",
		"./PaymentModal",
		3580
	],
	"5181": [
		"default",
		"./PaymentHistory",
		3580
	],
	"5182": [
		"default",
		"./PaymentConfigurations",
		3580
	],
	"5183": [
		"default",
		"./PaymentPreferences",
		3580
	],
	"5184": [
		"default",
		"./ManagePaymentProcessing",
		3580
	],
	"5185": [
		"default",
		"./MobilePaymentsWrapper",
		3580
	],
	"5186": [
		"default",
		"./PayPage",
		3580
	],
	"5187": [
		"default",
		"./Challenge",
		3580
	],
	"5188": [
		"default",
		"./ManagePaymentMethods",
		3580
	],
	"5189": [
		"default",
		"./LightspeedReports",
		3580
	],
	"5190": [
		"default",
		"./ActivateLightspeedPayments",
		3580
	],
	"5191": [
		"default",
		"./MarketingLandingPage",
		3580
	],
	"5192": [
		"default",
		"./ShippingPromotionsListContainer",
		3580
	]
};
var idToRemoteMap = {
	"4055": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3670
		}
	],
	"4348": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3670
		}
	],
	"4648": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5082": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5169": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5170": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5173": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5174": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5175": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5176": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5177": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5178": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5179": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5180": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5181": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5182": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5183": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5184": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5185": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5186": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5187": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5188": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5189": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5190": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5191": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5192": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}